module.exports = __webpack_public_path__ + "static/media/preview@768.bdf12566.png";